import ApiService from '../apiService';
// import sortBy from 'lodash/sortBy';
// import get from 'lodash/get';
// import { trackEvent } from '@/utils/tracking';

// helper function to get the appropriate API instance
const api = () => {
  return ApiService.instanceApiGateway;
};

export default {
  /**
   * @param {Object} data
   * @param {string} data.title
   * @param {string} data.tenandId
   * @param {string} data.templateId
   * @param {string} data.parentId?
   * @returns {Promise<Object>}
   */
  async createTemplate(data) {
    const response = await api().post('/digitaltwin-templates', data);
    return response.data;
  },
  /**
   * @param {Object} options
   * @param {Number[]} options.tenantIds
   * @param {Number} options.limit
   * @param {Number} options.offset
   * @param {Number} options.level
   * @param {String} options.parentId
   * @returns {Promise<Object>}
   */
  async fetchTemplates(options) {
    const response = await api().get('/digitaltwin-templates', { params: options });
    const children = response.data.children.map((item) => ({
      ...item,
      children: item.childrenTotal > 0 ? [] : null,
    }));

    return { ...response.data, children };
  },
};
